import React, { Fragment, useState } from 'react'
import { FaGoogle, FaFacebook } from 'react-icons/fa';

import './styles.sass';

import { LoadingSpinner } from '../LoadingSpinner';

const LoginForm = ({ socialLogin }) => {
  const [isLoading, setIsLoading] = useState(false);

  const login = (provider) => {
    setIsLoading(true);
    socialLogin(provider, () => setIsLoading(false));
  }

  const socialIcon = (provider) => {
    return provider === 'Facebook' ? <FaFacebook /> : <FaGoogle />;
  }

  const SocialButton = ({ socialType }) => {
    return (
      <button className={"button is-fullwidth is-hovered mt-3 has-text-white	is-" + socialType.toLowerCase()}
        onClick={() => { login(socialType) }}>
        <span className="icon">{socialIcon(socialType)}</span>
        <span>{socialType}</span>
      </button>
    );
  }

  const LoginFragment = () => {
    return (
      <Fragment>
        <h4 className="subtitle is-6 mb-4">Log in with one of the following</h4>
        <SocialButton socialType="Facebook" />
        <SocialButton socialType="Google" />
      </Fragment>
    );
  }

  return (
    isLoading
      ? <LoadingSpinner message="Processing..." loaderColor='#00d1b2' loaderType='ThreeDots' />
      : <LoginFragment />
  )
}

export default LoginForm
